import { NgModule } from '@angular/core';

import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { routerReducer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { RouterEffects, KeyboardEffects } from '@hglobal/common';
import { environment } from '@pt/environment';
import { authReducer, AuthEffects } from '@pt/auth';

import { RootState, UiEffects } from './';

@NgModule({
  imports: [
    StoreModule.forRoot<RootState>({
      router: routerReducer,
      auth: authReducer,
    }),
    EffectsModule.forRoot([RouterEffects, AuthEffects, KeyboardEffects, UiEffects]),
    StoreDevtoolsModule.instrument({
      name: 'RedCore',
      maxAge: 25,
      logOnly: environment.production,
    }),
    StoreRouterConnectingModule.forRoot(),
  ],
})
export class RootStoreModule {
}
